import { LocalStorageService } from './local-storage.service';
import { Location } from '@angular/common';
import { Injectable, OnInit, Inject, forwardRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class TranslationService implements OnInit{
  private changeLangage = new Subject<void>;
  public changeLangage$ = this.changeLangage.asObservable();

  selectedLanguage: string = '';
  // Retrieve current language selected from local storage
  languageStatus:string = this.localStorageService.getItem('language');
  constructor(@Inject(forwardRef(() => TranslateService)) @Inject(forwardRef(() => TranslateService)) private translate: TranslateService, private localStorageService:LocalStorageService,
            private location: Location) {

  }
  ngOnInit(): void {

  }

  setLanguage(){
     // Choose language: localStorage -> browser -> default 'fr'
      const stored = this.localStorageService.getItem('language');
      const browserLang = this.translate.getBrowserLang();
      const lang = stored || browserLang || 'fr';

      // Persist normalized language
      this.localStorageService.addItem('language', lang);
      this.languageStatus = lang;

      // Set default and active language to avoid key flashes
      this.translate.setDefaultLang('fr');
      this.translate.use(lang);
  }


  // Define language used to translate
  translateTo(language:string) {
    this.localStorageService.addItem('language', language);
    this.languageStatus = language;
    this.translate.use(language)
  }

  selectLangageChange(){
    this.changeLangage.next();
  }
}


